import { TMobileRouterPath, useAppNavigate } from "../../../hooks/router";
import { useLocation } from "react-router-dom";
import { useEffect, FC } from "react";
import styles from "./styles.module.scss";

interface IProps {
  tabs: ITabObject[];
  tapEvent: (event: string) => void;
}

let lastMainPath = "";

export const Footer: FC<IProps> = ({ tabs, tapEvent }) => {
  const location = useLocation();
  const navigate = useAppNavigate();

  const setRouteActive = (route: string) => {
    navigate(route);
    tapEvent(route);
  };

  useEffect(() => {
    tapEvent(location.pathname);
  }, []);

  lastMainPath = tabs
    .map((val) => val.key)
    .includes(location.pathname as TMobileRouterPath)
    ? location.pathname
    : lastMainPath;

  useEffect(() => {
    const footer = document.getElementsByClassName(`footer-${lastMainPath}`)[0];
    if (footer) {
      // @ts-ignore
      footer.onclick = () => navigate(lastMainPath);
    }
  }, [lastMainPath, navigate]);

  return (
    <div className={styles.tabBar}>
      {tabs.map((item) => {
        const isActive = lastMainPath === item.key;
        return (
          <button
            key={item.key}
            type="button"
            className={`footer-${item.key} ${styles.tabItem} ${
              isActive ? styles.tabItemActive : ""
            }`}
            onClick={() => setRouteActive(item.key)}
            aria-label={item.title}
          >
            <span className={styles.tabIcon}>{item.icon}</span>
            <span className={styles.tabLabel}>{item.title}</span>
          </button>
        );
      })}
    </div>
  );
};
